import _Vue from "vue";
import UiNotificationComponent from "./ui-notification.vue";
import NotificationOptions, {
  EnumNotificationType
} from "./model/notificationOptions";

export default class Notification {
  private mounted = false;
  private $root: UiNotificationComponent;
  constructor() {}

  success(message: string, title = ""): void {
    this.open(
      new NotificationOptions(title, message, EnumNotificationType.Success)
    );
  }
  error(message: any, title = "Ошибка"): void {
    this.open(
      new NotificationOptions(title, this.normalizeMessage(message), EnumNotificationType.Error)
    );
  }
  private open(data: NotificationOptions): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.mountIfNotMounted();
      (this.$root as any).show(data);
      (this.$root as _Vue).$once("change", (res: any) => {
        resolve(res);
      });
    });
  }
  private mountIfNotMounted() {
    if (this.mounted === true) {
      return;
    }
    let NotificationConstructor = _Vue.extend(UiNotificationComponent);
    this.$root = new NotificationConstructor();
    let node = document.createElement("div");
    document.querySelector("body").appendChild(node);
    this.$root.$mount(node);
    this.mounted = true;
  }

  private normalizeMessage(message: any): string {
    if (!message) {
      return "Неизвестная ошибка";
    }
    if (typeof message === "string") {
      return message;
    }
    if (message instanceof Error) {
      return message.message || "Неизвестная ошибка";
    }
    if (typeof message === "object") {
      return (
        message.ErrorMessage ||
        message.message ||
        message.error ||
        message.title ||
        this.buildApiErrorMessage(message) ||
        "Неизвестная ошибка"
      );
    }
    return String(message);
  }

  private buildApiErrorMessage(message: any): string {
    const method = message.Method ? String(message.Method) : "";
    const className = message.Class ? String(message.Class) : "";
    if (!className && !method) {
      return "";
    }
    return [className, method].filter(Boolean).join(".");
  }
}
